module.exports = __webpack_public_path__ + "static/fonts/Avenir-Book.9241048.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Avenir/Avenir-Book.ttf
// module id = Vv/l
// module chunks = 0